var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportAnswers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.37431 1.89552V3.38518H1.90632V13.0679H12.3316V8.59896H13.821V14.5576H0.416992V1.89552H6.37431ZM11.3689 0.624023L14.8741 4.13L11.3689 7.63598L10.3157 6.58264L12.0228 4.87481L10.0976 4.87483C8.9079 4.87483 7.93538 5.80506 7.86743 6.97801L7.86364 7.10931V10.8334H6.37431V7.10931C6.37431 5.10665 7.95472 3.4732 9.93613 3.38862L10.0976 3.38518L12.0227 3.38514L10.3157 1.67737L11.3689 0.624023Z",
    fill: "#498E2B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportAnswers);
export default __webpack_public_path__ + "static/media/export-answers.cc56a6f7e95c3515956e9e5ee6e800a5.svg";
export { ForwardRef as ReactComponent };